import { Button } from "reactstrap";
import { contactUsStyle } from "../styles/mainStyles";

function ButtonContactUs({ onClick, title, size = "lg" }) {
    return (
        <>
            <Button
                onClick={onClick}
                style={contactUsStyle}
                size={size}
                onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseOut={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
                }
            >
                {title}
            </Button>
        </>
    );
}

export default ButtonContactUs;
